export default {
  title: 'Profil',
  headerSubtitle: 'Verwalte deine persönlichen Daten und Einstellungen',

  tabs: {
    personal: 'Persönliche Daten',
    nutrition: 'Ernährungspräferenzen',
    security: 'Sicherheit & Datenschutz',
    subscription: 'Abo & Zahlungen',
    referral: 'Empfehlungsprogramm',
  },

  personal: {
    title: 'Persönliche Informationen',
    subtitle: 'Verwalte deine grundlegenden Profildaten',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail-Adresse',
    gender: 'Geschlecht',
    genderOptions: {
      male: 'Männlich',
      female: 'Weiblich',
      diverse: 'Divers',
    },
    age: 'Alter',
    ageUnit: 'Jahre',
    language: 'Sprache',
    languageOptions: {
      de: 'Deutsch',
      en: 'English',
    },
  },

  body: {
    title: 'Körperdaten',
    subtitle: 'Deine aktuellen Körperwerte',
    height: 'Körpergröße',
    heightUnit: 'cm',
    currentWeight: 'Aktuelles Gewicht',
    weightUnit: 'kg',
    targetWeight: 'Zielgewicht',
    bmi: 'BMI (Body Mass Index)',
    bmiCategories: {
      underweight: 'Untergewicht',
      normal: 'Normalgewicht',
      overweight: 'Übergewicht',
      obese: 'Adipositas',
    },
    remaining: 'Noch',
  },

  goals: {
    title: 'Ziele & Aktivität',
    subtitle: 'Definiere deine Fitness- und Ernährungsziele',
    mainGoal: 'Hauptziel',
    goalOptions: {
      lose: 'Abnehmen',
      build: 'Muskeln aufbauen',
      maintain: 'Gewicht halten',
    },
    activityLevel: 'Aktivitätslevel',
    activityOptions: {
      sedentary: 'Sitzend (wenig Bewegung)',
      lightly: 'Leicht aktiv (1-3 Tage/Woche)',
      moderately: 'Moderat aktiv (3-5 Tage/Woche)',
      very: 'Sehr aktiv (6-7 Tage/Woche)',
      extremely: 'Extrem aktiv (2x täglich)',
    },
    weeklyGoal: 'Ich möchte abnehmen:',
    weeklyGoalUnit: 'kg/Woche',
    weeklyGoalRecommendation: 'Empfohlener wöchentlicher Gewichtsverlust: 0,5 kg/Woche',
  },

  dietary: {
    title: 'Ernährungspräferenzen',
    subtitle: 'Passe deine Ernährung an deine Bedürfnisse an',
    dietType: 'Ernährungstyp',
    dietOptions: {
      balanced: 'Ausgewogen',
      vegetarian: 'Vegetarisch',
      vegan: 'Vegan',
      keto: 'Keto',
      paleo: 'Paleo',
      halal: 'Halal',
    },
    allergies: 'Allergien & Unverträglichkeiten',
    allergiesPlaceholder: 'z.B. Laktose, Gluten, Nüsse',
    allergiesHint: 'Mehrere Allergien mit Komma trennen',
    commonAllergies: {
      lactose: 'Laktose',
      gluten: 'Gluten',
      nuts: 'Nüsse',
      soy: 'Soja',
      eggs: 'Eier',
      fish: 'Fisch',
      shellfish: 'Meeresfrüchte',
    },
    dislikes: 'Unbeliebte Lebensmittel',
    dislikesPlaceholder: 'z.B. Rosenkohl, Oliven, Pilze',
    dislikesHint: 'Lebensmittel, die du nicht magst',
    mealsPerDay: 'Mahlzeiten pro Tag',
    mealsOptions: {
      2: '2 Mahlzeiten',
      3: '3 Mahlzeiten',
      4: '4 Mahlzeiten',
      5: '5 Mahlzeiten',
    },
  },

  security: {
    title: 'Sicherheit & Datenschutz',
    subtitle: 'Schütze dein Konto',

    password: {
      title: 'Passwort ändern',
      current: 'Aktuelles Passwort',
      new: 'Neues Passwort',
      confirm: 'Neues Passwort bestätigen',
      requirements: 'Mindestens 8 Zeichen, 1 Großbuchstabe, 1 Zahl',
      changeButton: 'Passwort ändern',
      cancelButton: 'Abbrechen',
    },

    twoFactor: {
      title: 'Zwei-Faktor-Authentifizierung',
      description: 'Erhöhe die Sicherheit deines Kontos',
      enabled: 'Aktiviert',
      disabled: 'Deaktiviert',
      enableButton: 'Aktivieren',
      disableButton: 'Deaktivieren',
      disableConfirm: 'Möchtest du 2FA wirklich deaktivieren?',
      qrTitle: 'Scanne diesen QR-Code',
      qrDescription: 'Verwende eine Authenticator-App wie Google Authenticator oder Authy',
      verifyCode: 'Bestätigungscode eingeben',
      verifyButton: 'Verifizieren',
    },

    devices: {
      title: 'Verbundene Geräte',
      description: 'Verwalte Geräte mit Zugriff auf dein Konto',
      current: 'Aktuelles Gerät',
      lastLogin: 'Letzter Login',
      revokeButton: 'Zugriff widerrufen',
      revokeConfirm: 'Möchtest du den Zugriff dieses Geräts wirklich widerrufen?',
    },
  },

  subscription: {
    title: 'Abo & Zahlungen',
    subtitle: 'Verwalte dein Abonnement',

    noplan: {
      title: 'Kein aktives Abo',
      subtitle: 'Wähle einen Plan, um dein personalisiertes Ernährungserlebnis freizuschalten.',
      cta: 'Pläne ansehen',
    },

    plan: {
      current: 'Aktuelles Abo',
      basic: 'BASIC',
      vip: 'VIP',
      status: 'Status',
      statusActive: 'Aktiv',
      statusCanceling: 'Wird gekündigt',
      statusTrialing: 'Testphase',
      statusPastDue: 'Zahlung fehlgeschlagen',
      statusCancelled: 'Gekündigt',
      price: 'Preis',
      nextBilling: 'Nächste Abrechnung',
      validUntil: 'Gültig bis',
      upgradeButton: 'Auf VIP upgraden',
      downgradeButton: 'Plan wechseln',
      cancelButton: 'Abo kündigen',
      cancelingNotice: 'Dein Abo endet am {{date}}. Du behältst bis dahin vollen Zugriff.',
    },

    pastDue: {
      title: 'Zahlung fehlgeschlagen',
      hint: 'Bitte aktualisiere deine Zahlungsmethode, um dein Abo aktiv zu halten.',
    },

    payment: {
      title: 'Zahlungsmethode',
      type: 'Typ',
      cardNumber: 'Kartennummer',
      expiry: 'Gültig bis',
      cvv: 'CVV',
      changeButton: 'Zahlungsmethode ändern',
      saveButton: 'Speichern',
      cardPlaceholder: '1234 5678 9012 3456',
      expiryPlaceholder: 'MM/JJ',
      cvvPlaceholder: '123',
      portalHint: 'Aktualisiere deine Zahlungsmethode sicher über das Stripe-Kundenportal.',
    },

    invoices: {
      title: 'Rechnungen',
      date: 'Datum',
      amount: 'Betrag',
      status: 'Status',
      download: 'Herunterladen',
      statusPaid: 'Bezahlt',
      statusPending: 'Ausstehend',
      statusFailed: 'Fehlgeschlagen',
      viewAll: 'Alle Rechnungen ansehen',
      portalHint: 'Lade deine Rechnungen herunter und verwalte deinen Zahlungsverlauf im Stripe-Kundenportal.',
    },

    cancelModal: {
      title: 'Abo kündigen?',
      description: 'Bist du sicher, dass du dein Abo kündigen möchtest?',
      warning: 'Dein Abo läuft noch bis zum {{date}}. Du behältst bis dahin vollen Zugriff.',
      reasonLabel: 'Grund für Kündigung (optional)',
      reasonPlaceholder: 'Was können wir besser machen?',
      confirmButton: 'Abo kündigen',
      cancelButton: 'Abbrechen',
    },
  },

  buttons: {
    edit: 'Bearbeiten',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    close: 'Schließen',
    confirm: 'Bestätigen',
    understand: 'Verstanden',
  },

  info: {
    vipNote: 'Änderungen an deinen Ernährungspräferenzen werden automatisch in deinem nächsten Plan berücksichtigt. Du kannst jederzeit einen neuen Plan generieren lassen.',
    basicNote: 'Mit dem Basic Plan kannst du deine Daten bearbeiten, aber Änderungen am Ernährungsplan sind erst nach 30 Tagen möglich. Upgrade auf VIP für unbegrenzte Anpassungen!',
    unsavedChanges: 'Du hast ungespeicherte Änderungen. Möchtest du diese wirklich verwerfen?',
  },

  success: {
    profileUpdated: 'Profil erfolgreich aktualisiert!',
    passwordChanged: 'Passwort erfolgreich geändert!',
    twoFactorEnabled: '2FA erfolgreich aktiviert!',
    twoFactorDisabled: '2FA deaktiviert',
    deviceRevoked: 'Gerätezugriff widerrufen',
    subscriptionCancelled: 'Abo gekündigt. Zugriff bis {{date}}',
    paymentUpdated: 'Zahlungsmethode aktualisiert',
  },

  error: {
    loadProfile: 'Profil konnte nicht geladen werden',
    saveProfile: 'Profil konnte nicht gespeichert werden',
    passwordChange: 'Passwort konnte nicht geändert werden',
    twoFactorToggle: '2FA konnte nicht aktiviert/deaktiviert werden',
    deviceRevoke: 'Gerätezugriff konnte nicht widerrufen werden',
    subscriptionCancel: 'Abo konnte nicht gekündigt werden',
    paymentUpdate: 'Zahlungsmethode konnte nicht aktualisiert werden',
    fillAllFields: 'Bitte fülle alle Felder aus',
    passwordMismatch: 'Die Passwörter stimmen nicht überein',
    passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein',
  },

  chatbot: {
    title: 'NutriBot Coach',
    subtitle: 'Deine Profil-Änderungen wurden gespeichert',
    updateMessage: '🎉 **Profil erfolgreich aktualisiert!**\n\n📝 **Folgende Änderungen wurden gespeichert:**\n\n{changes}\n\n⚠️ **WICHTIG: Möchtest du deine Daten automatisch anpassen?**\n\nBasierend auf deinen neuen Profil-Daten können wir automatisch anpassen:\n\n📋 **Ernährungsplan** - Neue Kalorienziele und Makros\n👨‍🍳 **Rezeptliste** - Angepasst an deine Ernährungspräferenzen\n🛒 **Einkaufsliste** - Aktualisierte Zutaten\n\n💡 **Antworte mit \"Ja\" oder \"Nein\"**\n\n• **Ja** = Alle Daten werden automatisch angepasst\n• **Nein** = Nur Profil wird aktualisiert, Plan bleibt unverändert',
    noChanges: '✅ **Keine Änderungen vorgenommen.**\n\nDeine Daten sind bereits aktuell.',
    accessNote: '💡 NutriBot hat vollständigen Zugriff auf deine Profildaten',
  },
};